const vrContainer = document.querySelector(".js-360-vr-container"),
    vrCanvas = document.querySelector(".js-360-vr-viewer");

let viewer;

export function init() {
    const vrReferences = document.querySelectorAll(".js-360-vr");

    // On click to build 360 VR
    [...vrReferences].forEach(el => {
        el.addEventListener("click", load);
    });

    // Close/Hide 360 VR iframes
    vrContainer.addEventListener('click', (e) => {
        if (e.target !== vrContainer) {
            return false;
        }

        closeVr();
    });

    window.addEventListener('keydown', e => {
        const keyCode = e.keyCode;

        // If this is escape or enter, close the video
        if (keyCode === 27 || keyCode === 13) {
            closeVr();
        }
    });
}

function load(e) {
    e.preventDefault();

    const trigger = this;

    // Clear any previous HTML out of the canvas area
    vrCanvas.innerHTML = '';

    // Show and fadeIn VR container
    vrContainer.style.display = "block";

    setTimeout(function() {
        vrContainer.classList.add("visible");
        
        // Set the image
        viewer = pannellum.viewer('js-360-vr-viewer', {
            type: "equirectangular",
            panorama: trigger.dataset.img360,
            autoLoad: true
        });

        viewer.on('fullscreenchange', (status) => {
            if (status) {
                vrContainer.classList.add('fullscreen');
            } else {
                vrContainer.classList.remove('fullscreen');
            }
        });
    }, 250);
}

function closeVr(e) {
    // Fadeout overlay
    vrContainer.classList.remove("visible");

    // Set overlay to display:none after fadeout
    setTimeout(function() {
        vrContainer.style.display = "none";
    }, 500); // duration should be >= CSS transition time
}